import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import RingScene from "./components/RingScene";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function App() {
  const location = useLocation();
  const query = useQuery();

  const modelType = location.pathname.includes("bracelets")
    ? "bracelets"
    : location.pathname.includes("necklaces")
    ? "necklaces"
    : location.pathname.includes("earrings")
    ? "earrings"
    : "rings";

  const modelName = query.get("model") || "sakura";

  useEffect(() => {
    const bgParam = new URLSearchParams(location.search).get("bg");
    const disableBackground = bgParam === "none";

    if (disableBackground) {
      document.body.style.background = "none";
      document.documentElement.style.background = "none";
      console.log("nobg");
    } else {
      const bgUrl = "url('https://assets.mizora.jewelry/bg.jpg') no-repeat top/cover";
      document.body.style.background = bgUrl;
      document.documentElement.style.background = bgUrl;
      console.log("bg");
    }
  }, [location.search]); // Re-run on query string change

  return <RingScene modelType={modelType} modelName={modelName} />;
}
